<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Profissional responsável"
                show-legend
            >
                <FormProfissional
                    :data="{ form, model }"
                    @exit="exit"
                    @redirect="redirect"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Atendimento"
                class="mt-3"
            >
                <rkm-button
                    @click="openModal"
                    color="primary"
                    slot="trailing"
                    small
                    title="Adicionar"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <FormAtendimento
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos consolidados (total no período)"
            >
                <FormProcedimento
                    :data="{ form, model }"
                />
            </rkm-area>
        </rkm-form>

        <Modal
            :data="{ form, model }"
            ref="Modal"
        />
    </div>
</template>

<script>

// Mixins
import { repository, stringCase, data, object, formats, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

// Components
import FormProfissional from './components/profissional/Form.vue'
import FormAtendimento from './components/atendimento/Form.vue'
import FormProcedimento from './components/procedimento/Form.vue'
import Modal from './components/atendimento/Modal'

export default {
    components: {
        FormProfissional,
        FormAtendimento,
        FormProcedimento,
        Modal
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('atencaoBasica.procedimento')
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {},
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.procedimento.edit(this.id)
                    .then(response => {

                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        this.loaded = true
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {

                this.repositories.procedimento.create()
                    .then(response => {

                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        this.loaded = true
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                    this.setLoading()

                    this.repositories.procedimento.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())

            })
        },
        prepareData() {

            const id = this.model.id
            const cadastro = this.clone(this.model.cadastro)
            const atendimentos = this.clone(this.model.atendimentos)
            const procedimentoConsolidado = this.clone(this.model.procedimentoConsolidado)

            cadastro.usuario_id = cadastro.usuario.id
            cadastro.dataUsuarioResponsavel = this.getFormatedDate(cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive({
                id, cadastro, atendimentos, procedimentoConsolidado
            })
        },
        showArea() {

            return this.model.cadastro.usuario.id
                && this.model.cadastro.infraestruturaId
                && this.model.cadastro.equipeId
                && this.model.cadastro.ocupacaoId
                && this.model.cadastro.dataUsuarioResponsavel
        },
        openModal() {

            if (!this.showArea()) {

                this.showAlert(`É essencial fornecer as informações do profissional, unidade, local de atendimento,
                    equipe, ocupação e data para realizar o cadastro de um atendimento.`, "Atenção")

                return false
            }

            if (this.model.atendimentos.length >= 99) {

                this.showAlert(`O número máximo de 99 atendimentos por ficha foi atingido. Uma nova ficha deve ser
                    criada para o profissional, considerando as configurações essenciais, tais como unidade, local de
                    atendimento, equipe, ocupação e data.`, "Atenção")
            } else {

                this.$refs.Modal.open()
            }
        },
        redirect(id) {

            this.$emit('redirect', id)
        },
        exit() {

            this.$emit('save')
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: [Number, String], default: null },
    }
}
</script>